import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
    getAuth,
    verifyPasswordResetCode,
    confirmPasswordReset,
} from "firebase/auth";
import LoadingInline from "../components/LoadingInline";

export default function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const auth = getAuth();

    const mode = searchParams.get("mode");
    const oobCode = searchParams.get("oobCode");
    const continueUrl = searchParams.get("continueUrl") || "/login";

    const [email, setEmail] = useState<string | null>(null);
    const [newPassword, setNewPassword] = useState("");
    const [confirmed, setConfirmed] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    // リンクの検証
    useEffect(() => {
        if (mode !== "resetPassword" || !oobCode) {
            setError("パスワード再設定リンクが無効です。");
            setLoading(false);
            return;
        }

        verifyPasswordResetCode(auth, oobCode)
            .then((mail) => {
                setEmail(mail);
                setLoading(false);
            })
            .catch((e: any) => {
                console.error("verifyPasswordResetCode error:", e.code, e.message);
                setError("このパスワードリセットリンクは無効または期限切れです。");
                setLoading(false);
            });
    }, [auth, mode, oobCode]);

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError("");

        if (!oobCode) {
            setError("リセットコードが見つかりません。");
            return;
        }
        if (!newPassword || newPassword.length < 6) {
            setError("パスワードは6文字以上で入力してください。");
            return;
        }
        if (newPassword !== confirmed) {
            setError("パスワードが一致しません。");
            return;
        }

        try {
            await confirmPasswordReset(auth, oobCode, newPassword);
            setSuccess(true);

            setTimeout(() => {
                navigate(continueUrl);
            }, 1500);
        } catch (e: any) {
            console.error("confirmPasswordReset error:", e.code, e.message);
            setError("パスワード再設定に失敗しました。");
        }
    }

    if (loading) return <LoadingInline />;

    if (success) {
        return (
            <div className="max-w-md mx-auto mt-10 p-6 border rounded-lg shadow">
                <h2 className="text-xl font-bold mb-4">パスワード再設定完了</h2>
                <p>パスワードを更新しました。ログイン画面へ移動します…</p>
            </div>
        );
    }

    return (
        <div className="max-w-md mx-auto mt-10 p-6 border rounded-lg shadow">
            <h2 className="text-xl font-bold mb-4">パスワード再設定</h2>

            {error && <p className="mb-4 text-red-600">{error}</p>}

            {email && (
                <p className="mb-4 text-gray-700">
                    <b>{email}</b> のパスワードを再設定します。
                </p>
            )}

            <form onSubmit={handleSubmit}>
                <label className="block mb-2 font-medium">新しいパスワード</label>
                <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="w-full p-2 border rounded mb-4"
                />

                <label className="block mb-2 font-medium">
                    新しいパスワード（確認）
                </label>
                <input
                    type="password"
                    value={confirmed}
                    onChange={(e) => setConfirmed(e.target.value)}
                    className="w-full p-2 border rounded mb-6"
                />

                <button
                    type="submit"
                    className="bg-blue-500 text-white w-full p-2 rounded hover:bg-blue-600"
                >
                    パスワードを更新
                </button>
            </form>
        </div>
    );
}
